// extracted by mini-css-extract-plugin
export default {"section":"kPWNh","wrapperGallery":"sJZ07 ZdH1P uFyfG","gallery":"SrHiN","slide":"iPbhj","progressBar":"jUMw4"};